(function () {
  function convert() {
    var oldCurrency = window.shopCurrency ? window.shopCurrency : '';
    var newCurrency = window.Currency.currentCurrency ? window.Currency.currentCurrency : '';

    if (oldCurrency && newCurrency) {
      window.Currency.convertAll(oldCurrency, newCurrency);
    }
  }
  function mainCode($) {
    $(document).on('Searchanise.AutocompleteUpdated', convert);
    $(document).on('Searchanise.ResultsUpdated', convert);
    $(document).on('Searchanise.RecommendationUpdated', convert);
  }
  function waitUntilDefined() {
    if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
      mainCode(Searchanise.$);
    } else {
      setTimeout(waitUntilDefined, 400);
    }
  }
  waitUntilDefined();
})();